<template>
  <modal @before-open="beforeOpen" @opened="opened" :resizable="true" @before-close="beforeClose" name="noticeDetail"
         :draggable="'.header'" :reset="true" :classes="['todobox','generalbox']" :adaptive="true"
         :height="width" :width="height" :max-width="maxWidth" :max-height="maxHeight" :min-width="1092"
         :pivotX="modalOffsetDistance.x" :pivotY="modalOffsetDistance.y"
         :min-height="614" :click-to-close="false">
    <div @click="close" class="close">
      <i class="iconfont icon-cha"></i>
    </div>
    <div class="header">
      <h2 v-if="false">{{modalTitle}}</h2>
      <h2>通知公告详情</h2>
    </div>
    <div v-if="noticeData.state===2 && auditPower" class="topper">
      <button @click="noticeHandle(1)" class="agree">通过</button>
      <button @click="noticeHandle(3)" class="reject">驳回</button>
    </div>
    <div class="content">
      <div v-if="recommendList.length" class="recommend">
        <h2>相关推荐</h2>
        <ul>
          <li @click="reloadNotice(item)" :title="item.title" v-for="item in recommendList"><i
          class="iconfont icon-biaoti"></i>{{item.title}}
          </li>
        </ul>
      </div>
      <div v-if="!isExtraNotice" class="insideContent">
        <h2>

          {{noticeData.title}}
          <i v-if="noticeData.state===2" class="verify iconfont icon-shenhezhong2"></i>
          <i v-if="noticeData.state===3" class="reject verify iconfont icon-zhuangtaiyibohui"></i>
        </h2>
        <p>发布人：{{noticeData.username}} &nbsp;&nbsp;发布时间：{{noticeData.time}} &nbsp;&nbsp;来自：{{noticeData.sysName}} &nbsp;&nbsp;部门：{{noticeData.deptname}}</p>
        <div v-if="noticeData.showType === 'pdf'" class="pdfContent">
          <iframe :src="getPDFPreviewURL" frameborder="0"></iframe>
        </div>
        <div class="mainContent" v-html="noticeData.content"></div>
        <ul v-if="filesList.length" class="fileList">
          <li v-for="file in filesList" :key="file.id">
            <a :href="file.filepath" target="_blank" :download="file.filename">
              <i class="iconfont icon-fujian"></i>
              <p>{{file.filename}}</p>
            </a>
          </li>
        </ul>
      </div>

      <div v-if="isExtraNotice" class="extraPageContainer">
        <iframe class="extraPage" :src="pageURL" frameborder="0"></iframe>
      </div>

    </div>
  </modal>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config';
  //vuex
  import {mapState, mapGetters, mapMutations} from 'vuex';
  //通信总线
  import Bus from 'common/js/bus.js';

  export default {
    name: "noticeDetail",
    data() {
      return {
        pageURL: null,
        modalTitle: null,
        width: '80%',
        maxWidth: 1540,
        height: '80%',
        maxHeight: 885,
        infoData: {},
        noticeData: {},
        isExtraNotice: true,
        auditPower: false,
        filesList: [],
        fileDomain: null,

        //相关推荐
        recommendList: [],

      }
    },
    methods: {
      ...mapMutations(['updateModalZIndex']),
      close() {
        this.filesList = []
        this.$modal.hide("noticeDetail");
      },
      async beforeOpen(data) {
        this.pageURL = data.params.url;
        this.modalTitle = data.params.title;
        this.infoData = data.params.data;
        if (data.params) {
          this.auditPower = data.params.auditPower
        }
        console.log("%c当前通知公告来自：" + this.infoData.sysId, "font-size:50px;color:#f60;font-weight:bold;font-family:'微软雅黑'");
        if (this.infoData.sysId === "ehall") {
          this.initEhallNoticeContent()
        }
        if (data.params.setModalSize) {
          this.width = data.params.width;
          this.height = data.params.height;
          this.maxWidth = 999999;
          this.maxHeight = 999999;
        }
      },
      _initFilesList() {
        let fileObj = {}
        this.filesList = this.noticeData.attachmentlist
        this.fileDomain = this.noticeData.domain
      },
      //初始化通知公告内容
      async initEhallNoticeContent() {
        this.isExtraNotice = false;
        let currNoticeData = await axios.post(apiConfig.REQUEST_URL + "/shall/front_getNotice?id=" + this.infoData.id);
        currNoticeData = currNoticeData.data.data[0];
        this.noticeData = currNoticeData;
        this._initFilesList()
        this.fetchRecommend()
      },
      opened() {
        this.updateModalZIndex(this.$el)
      },
      beforeClose() {
        this.noticeData = {};
        this.isExtraNotice = true;
      },
      async noticeHandle(type) {

        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_updateNotice?' + this.$qs.stringify({
          id: this.noticeData.id,
          state: type
        }))
        if (!resp.data.status) {
          return
        }
        this.initEhallNoticeContent()
        Bus.$emit('refresh')
        this.$notify({
          group: 'global',
          title: '温馨提示',
          text: resp.data.msg
        })
      },
      downloadFile(file) {
        window.open(file.filepath)
      },
      async fetchRecommend() {
        let paramStr = this.$qs.stringify({
          noticeSort: this.noticeData.sort,
          pageNumber: 1,
          pageSize: 5,
          state: 1,
          type: -1
        })
        let resp = await axios.post(apiConfig.REQUEST_URL + '/shall/front_getNoticeList?' + paramStr)
        if (resp.data.status !== 1) {
          return
        }
        this.recommendList = resp.data.data[0].list
      },
      reloadNotice(noticeItem) {
        this.infoData = noticeItem
        this.initEhallNoticeContent()

      }
    },
    computed: {
      ...mapState(['modalOffsetDistance']),
      //获取PDF预览地址
      getPDFPreviewURL() {
        if (this.noticeData.showType !== 'pdf') {
          return
        }
        let fileURL = encodeURIComponent(this.noticeData.filepath)
        let iframeURL = apiConfig.REQUEST_URL + '/shall/pdfviewer/web/viewer.html?file=' + fileURL
        return iframeURL
      }
    },
    mounted() {
    },
    filters: {},
    components: {}
  }
</script>

<style lang="stylus" scoped>
  @import "../../common/stylus/config.styl"

  .topper
    text-align right
    padding 10px
    position absolute
    top 50px
    left 0
    right 0
    z-index 99

    p
      display inline-block
      font-size 14px
      color #666666
      margin-right 20px

    & > button
      padding 5px 20px
      margin-right 10px
      border none
      border-radius 20px
      outline none
      color #ffffff
      background-color #ffffff
      transition 300ms

      &:hover
        background-color #f1f1f1

      &.agree
        background #439239

        &:hover
          background #58C94C

      &.reject
        background #ff6666

        &:hover
          background #A44646

  .content
    position relative

    .recommend
      float right
      width 200px
      height 100%
      padding-left 10px
      border-left 1px solid #f1f1f1

      h2
        line-height 50px
        color themeColor
        border-bottom 1px solid #f1f1f1
        margin-bottom 20px

      ul
        li
          font-size 14px
          line-height 1.5
          border-bottom 1px solid #f1f1f1
          padding-bottom 5px
          margin-bottom 5px
          white-space nowrap
          overflow hidden
          text-overflow ellipsis
          cursor pointer
          a
            display block
            width 100%
          &:hover
            color themeColor

          i.iconfont
            vertical-align middle
            font-size 12px
            margin-right 5px
            color themeColor

  .extraPageContainer
    width 100%
    height 100%

    .extraPage
      width 100%
      height 100%

  .insideContent
    overflow hidden

    & > h2
      font-size 18px
      line-height 40px
      margin-top 10px
      color #333333
      text-align center

      .verify
        margin-left 10px
        border none
        color #004a94
        font-size 18px
        vertical-align middle

        &.reject
          font-size 24px

    & > p
      font-size 14px
      line-height 30px
      color #666666
      text-align center

    & > .mainContent
      font-size 14px
      color #333333
      padding 20px 25px
      line-height 30px

    & > .pdfContent
      margin-top 10px
      font-size 14px
      color #333333
      border-bottom 1px solid #999999
      height 600px

      iframe
        width 100%
        height 100%

  .fileList
    padding 10px

    li
      border 1px solid #cccccc
      cursor pointer
      width 260px
      height 32px
      margin-top 10px
      font-size 14px
      line-height 32px
      padding 0 10px
      border-radius 20px
      display inline-block
      color #666
      white-space nowrap
      overflow hidden
      text-overflow ellipsis
      margin-right 10px
      position relative
      transition 300ms

      &:hover
        background-color #eeeeee

      p
        display inline-block
        width 180px
        overflow hidden
        text-overflow ellipsis
        white-space nowrap
        vertical-align middle

      /*vertical-align middle*/

      .del
        position absolute
        right 0
        top 0
        bottom 0
        width 30px
        text-align center
        line-height 30px
        color #999999

        i.iconfont
          font-size 20px

        &:hover
          color #333333

      & > i.iconfont
        vertical-align middle
        margin-right 5px
        display inline-block
        font-size 20px

</style>



// WEBPACK FOOTER //
// src/components/notice/noticeDetailModal.vue